declare var $: any;

function setupSubmitButton() {
  const submitButton = document.querySelector("input#id_submit.no-captcha") as HTMLInputElement;
  if (!submitButton) {
    return;
  }

  const form = $("form#spark-form");
  form.submit(() => {
    form.find("input[type=submit]").attr("disabled", "disabled").val("Please wait...");
  });
}

function setupTwoStepForm() {
  const form = document.getElementById("spark-form");
  const nextButton = document.getElementById("two-step-next");
  if (!form || !nextButton) {
    return;
  }

  function nextStep() {
    form.classList.add("step-two-active");
    const input: HTMLInputElement = document.querySelector('.step-two input[type="password"]');
    if (input) {
      input.focus();
    }
    nextButton.parentNode.removeChild(nextButton);
  }

  // Clear error when input changes
  const allFields = document.querySelectorAll("form .fields input");
  for (let idx = 0; idx < allFields.length; idx++) {
    const field = allFields[idx];
    field.addEventListener("change", (event) => {
      const element = event.currentTarget as HTMLInputElement;
      (element.parentNode as HTMLDivElement).classList.remove("errors");
    });
  }

  // Check if there is an error on first step
  const stepOneErrorElement = document.querySelector("form .step-one .errors");
  if (form.classList.contains("error") && !stepOneErrorElement) {
    nextStep();
    return;
  }

  const stepOneFields = form.querySelectorAll(".step-one.fields input");
  nextButton.addEventListener("click", (event) => {
    event.preventDefault();

    // Show empty fields errors when changing step
    form.querySelectorAll(".step-one .errors").forEach((e) => e.classList.remove("errors"));
    let hasError = false;
    for (let idx = 0; idx < stepOneFields.length; idx++) {
      const field = stepOneFields[idx] as HTMLInputElement;
      if (!field.required) {
        continue;
      }
      const value = field.value.trim();
      if (!value || value.length === 0) {
        (field.parentNode as HTMLDivElement).classList.add("errors");
        hasError = true;
      }
    }
    if (!hasError) {
      nextStep();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setupSubmitButton();
  setupTwoStepForm();
});
